import React from 'react';
import Reveal from '../components/Reveal';
import SectionHeading from '../components/SectionHeading';

const comparisons = [
  ['Die geilste Abriss-Party', 'Hamburgs schönste und bunteste Schlager-Party'],
  ['VIP Saufen', 'Eiskalte Drinks & heiße Beats'],
  ['Ballermann-Eskalation', 'Retro-Chic trifft auf moderne Festival-Kultur']
];

function CopySection() {
  return (
    <section className="section copy-section" id="copy">
      <div className="section-inner">
        <SectionHeading eyebrow="04 — So klingt die Marke" light>
          Wording
        </SectionHeading>
        <div className="copy-lead">
          <span className="copy-quote">“</span>
          <p>Wir kommunizieren fröhlich, energiegeladen, einladend und augenzwinkernd. Wir sind die guten Gastgeber für eine fantastische Party.</p>
          <span className="copy-lead-label">Tone of Voice</span>
        </div>
        <div className="comparison-heading">
          <span /> Dos &amp; Don’ts <span />
        </div>
        <div className="comparison-list">
          {comparisons.map(([no, yes], index) => (
            <Reveal className="comparison-row" delay={index * 0.08} key={no}>
              <div className="wording-no">
                <span>STATT</span>
                <p>„{no}“</p>
              </div>
              <span className="wording-arrow" aria-hidden="true">→</span>
              <div className="wording-yes">
                <span>SAGEN WIR</span>
                <p>„{yes}“</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CopySection;